import { Directive, ElementRef, Renderer2 } from "@angular/core";

@Directive({
  selector: "[slimScroll]",
})
export class SlimScrollDirective {
  constructor(private elementRef: ElementRef, private renderer: Renderer2) {
    this.renderer.addClass(this.elementRef.nativeElement, "slim-scrollbar");
  }
}
